import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			root: {
				width: "100%",
				zIndex: 3
			},
			bodyView: {
				padding: "0px 10px 15px"
			},
			rootOrder: {
				display: "flex",
				alignItems: "center",
				justifyContent: "space-between",
				padding: "8px 10px",
				background: theme.palette.primary.dark,
				border: `1px solid ${theme.palette.primary.light}`,
				boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.05)",
				borderRadius: 6
			},
			btnDefault: {
				background: theme.palette.primary.main,
				color: theme.palette.text.contrastText,
				lineHeight: 0,
				fontSize: 14,
				padding: "5px 20px",
				minHeight: 36,
				minWidth: 100,
				fontWeight: 400,
				borderRadius: 6,
				"&:active": {
					background: `${theme.palette.primary.light} !important`
				},
				"&:hover": {
					background: `${theme.palette.primary.light} !important`
				}
			},
			textProduct: {
				color: theme.palette.primary.contrastText,
				fontSize: 14,
				marginLeft: 5,
				textAlign: "center",
				minWidth: 50,
				"& > span": {
					fontWeight: 500,
					color: theme.palette.secondary.main
				}
			}
		}),
	{
		name: "ConfirmOrder",
		index: 1
	}
);

export default useStyles;
